/**
 * Tasks MV2 query API — isolated from MV1 pages/Tasks.jsx.
 */
import { getTasks, getTeamSettings } from "@/lib/api";

export const TASKS_QUERY_KEY = "tasks";
export const TASK_ASSIGNEES_QUERY_KEY = "task-assignees";

export async function fetchTasksFromApi(params, signal) {
  const res = await getTasks(params);
  if (signal?.aborted) throw new DOMException("Aborted", "AbortError");
  return res.data?.items || [];
}

export async function fetchTaskAssigneesFromApi(signal) {
  const res = await getTeamSettings();
  if (signal?.aborted) throw new DOMException("Aborted", "AbortError");
  return res.data?.task_assignees || [];
}
